export default "/img/DO.de6aaa8a280a797640f900a78afca8ef.png";